<template>
  <div>
    <div class="text-left">
      <div class="section-icon">🌍</div>
    </div>

    <!-- block -->
    <div class="block mt-4">
      <h1>Where am I?</h1>

      <p class="mt-4">
        Just like all of your team, I am also on the internet!
      </p>

      <p>
        But originally I come from a little country in Central Europe, called
        Slovenia. The country is small but really colorful. You could be
        climbing the mountains in the morning, swim in the sea by lunch, and
        have a stroll trough wine country by evening.<br />
      </p>

      <p>
        I come from a little town called Brestanica, also called Rajhenburg (old
        name). My town is known by two castles a big church and Adam Bohorič. He
        was an author of the first ever grammar of Slovene language. I visited
        grammar school named after him. Currently I live with my family (wife
        and 2 kids) in Ljubljana.
      </p>
    </div>

    <div class="embed-responsive embed-responsive-4by3">
      <iframe
        class="embed-responsive-item"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d707608.6367400574!2d14.432641479281553!3d46.14882972782718!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476524e75e968361%3A0xe740451e25e2d465!2sSlovenia!5e0!3m2!1sen!2ssi!4v1585840724958!5m2!1sen!2ssi"
        frameborder="0"
        style="border:0;"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0"
      ></iframe>
    </div>

    <div class="block">
      <p class="mt-4">
        <b>Fun facts:</b>
      </p>
      <ul>
        <li>
          there is only 2 million of us and we speak 46 different dialects
        </li>
        <li>our country looks like a chicken on the map! 🤭</li>
        <li>we have love in our name: S<b>love</b>nia, S❤️nia</li>
        <li>we have <b>a lot</b> of caves</li>
        <li>we have the world's largest ski jump</li>
      </ul>
    </div>
    <!-- ./ block -->

    <!-- block -->
    <div class="block">
      <h2>Interesting links</h2>
      <ul>
        <li>
          <a href="https://www.slovenia.info/en" target="_blank"
            >I Feel Slovenia</a
          >
        </li>
        <li>
          <a href="https://en.wikipedia.org/wiki/Brestanica" target="_blank"
            >Wikipedia: Brestanica</a
          >
        </li>
        <li>
          <a href="https://www.gradrajhenburg.si/en" target="_blank">
            Castle Rajhenburg</a
          >
        </li>
        <li>
          <a href="visitljubljana.com/en/visitors/" target="_blank"
            >Visit Ljubljana</a
          >
        </li>
        <li>
          <a
            href="https://www.swedishnomad.com/facts-about-slovenia/"
            target="_blank"
            >25 Interesting facts about Slovenia</a
          >
        </li>
        <li>
          <a href="https://www.bled.si/en/" target="_blank"> Lake Bled</a>
        </li>
        <li>
          <a href="https://www.postojnska-jama.eu/en/" target="_blank"
            >Postojna Cave</a
          >
        </li>
      </ul>
    </div>
    <!-- ./ block -->
  </div>
</template>

<script>
export default {
  name: 'Location'
}
</script>

<style></style>
